import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {baseUrl, tenant} from "Shared/BaseUrl";
import {USER_DETAILS} from "Shared/Tokens";
import {
  APP_LOCALIZATION,
  CALENDAR_LANG,
  CALENDAR_TYPE,
  TOKEN_KEY,
  PERMISSIONS,
  JOURNAL_VIEW_TYPE,
} from "Shared/Tokens";
import {createNotification} from "Utils/CreateNotification";

const userToken = localStorage.getItem(TOKEN_KEY);

export const logoutUser = createAsyncThunk("logout", async (data) => {
  var response = await fetch(baseUrl + "auth/logout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem(TOKEN_KEY),
        "X-Tenant": tenant,
    },
    body: JSON.stringify({token: "Bearer " + localStorage.getItem(TOKEN_KEY)}),
  });
  var res = await response.json();
  if (res.success) {
    createNotification("success", res.message);
  } else {
    createNotification("error", res.message);
  }
  // localStorage.removeItem(TOKEN_KEY);
  // localStorage.removeItem(CALENDAR_LANG);
  // localStorage.removeItem(CALENDAR_TYPE);
  // localStorage.removeItem(APP_LOCALIZATION);
  // localStorage.removeItem(USER_DETAILS);
  // localStorage.removeItem(PERMISSIONS);
  // localStorage.removeItem(JOURNAL_VIEW_TYPE);
  // localStorage.removeItem('purchaseDetails');
  // localStorage.removeItem('salesDetails');
  localStorage.clear();

  return {res: res};
});

const loginSlice = createSlice({
  name: "login",
  initialState: {
    login: userToken !== null ? true : false,
  },
  reducers: {
    toggleLogin: (state, action) => {
      state.login = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutUser.fulfilled, (state, action) => {
      state.login = false;
    });
  },
});

export const {toggleLogin} = loginSlice.actions;
export default loginSlice.reducer;
